export const CATALOG_GRID_PRODUCT_CARD_IMAGE_SIZES =
  "(max-width: 1023px) calc(50vw - 24px), (max-width: 1279px) calc((100vw - 360px) / 3), calc((100vw - 430px) / 4)"

export const FEATURED_CAROUSEL_PRODUCT_CARD_IMAGE_SIZES =
  "(max-width: 639px) 65vw, (max-width: 767px) 55vw, (max-width: 1023px) 35vw, 25vw"

export const SQUARE_THUMB_IMAGE_SIZES = "96px"

export const PRODUCT_GALLERY_MOBILE_IMAGE_SIZES =
  "(max-width: 767px) calc(100vw - 24px), 0px"

export const PRODUCT_GALLERY_DESKTOP_MAIN_IMAGE_SIZES =
  "(max-width: 1023px) calc(100vw - 24px), (max-width: 1840px) calc((100vw - 144px) / 2), 848px"

const FEATURED_CATEGORIES_ONE_COLUMN_SIZES =
  "(max-width: 767px) calc(100vw - 24px), (max-width: 1919px) calc(100vw - 96px), 1744px"

const FEATURED_CATEGORIES_TWO_COLUMNS_SIZES =
  "(max-width: 767px) calc(100vw - 24px), (max-width: 1919px) calc((100vw - 120px) / 2), 860px"

const FEATURED_CATEGORIES_THREE_COLUMNS_SIZES =
  "(max-width: 767px) calc(100vw - 24px), (max-width: 1919px) calc((100vw - 144px) / 3), 565px"

export const getProductCardImageSizes = (isFeatured?: boolean) =>
  isFeatured
    ? FEATURED_CAROUSEL_PRODUCT_CARD_IMAGE_SIZES
    : CATALOG_GRID_PRODUCT_CARD_IMAGE_SIZES

export const getFeaturedCategoriesImageSizes = (
  desktopColumnCount: number
) => {
  if (desktopColumnCount <= 1) {
    return FEATURED_CATEGORIES_ONE_COLUMN_SIZES
  }

  if (desktopColumnCount === 2) {
    return FEATURED_CATEGORIES_TWO_COLUMNS_SIZES
  }

  return FEATURED_CATEGORIES_THREE_COLUMNS_SIZES
}
